import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ReactNode, useEffect } from 'react';
import { useSortingContext } from 'utils/contexts/sorting';
import { useDebouncedState } from 'utils/hooks/useDebouncedState';
import {
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { SEARCH_PARAM_KEYS } from '../constants';
import { SearchParamsContext } from './SearchParamsContext';

const { ASCENDING, DESCENDING } = SORT_DIRECTIONS;

export const SearchParamsContextProvider = ({ children }: { children: ReactNode }) => {
  const { setSortBy, setSortDirection, sortBy, sortDirection } = useSortingContext();
  /**
   * Search term filter
   */
  const [searchParam, setSearchParam] = useSearchParamState({
    searchParamKey: SEARCH_PARAM_KEYS.search,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });
  const [debouncedSearch, search, setSearch] = useDebouncedState(searchParam, 300);
  useEffect(() => setSearchParam(search), [debouncedSearch]);

  const handleSort = (name: string) => {
    /** If click on selected column, only change sort direction */
    if (name === sortBy) {
      setSortDirection(sortDirection === ASCENDING ? DESCENDING : ASCENDING);
    } else {
      /** If click on new column, change sort by and start in default sort direction */
      setSortBy(name);
      setSortDirection(ASCENDING);
    }
  };

  const context = {
    debouncedSearch,
    handleSort,
    search,
    setSearch,
    sortBy,
    sortDirection,
  };

  return <SearchParamsContext.Provider value={context}>{children}</SearchParamsContext.Provider>;
};
